import { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../HomePage/Footer";
import {
  FaHome,
  FaCreditCard,
  FaStore,
  FaBoxOpen,
  FaTags,
  FaSignOutAlt,
  FaHistory,
  FaUsers,
  FaBars,
  FaTimes,
  FaCog,
  FaList,
  FaBullhorn
} from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import CreditCardPanel from "./CreditCardPanel";
import StoresPanel from "./StoresPanel";
import ProductPanel from "./ProductsPanel";
import DashboardPanel from "./DashboardPanel";
import ProductCategoryPanel from "./ProductCategory";
import SettingsPanel from "./SiteSettingPanel";
import UsersPanel from "./UsersPanel";
import DealsPanel from "./DealsPanel";
import MarketingPanel from "./MarketingPanel";

const AdminPage = () => {
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { logout } = useAuth();

  const menuItems = [
    { name: "Dashboard", icon: <FaHome /> },
    { name: "Users", icon: <FaUsers /> },
    { name: "Product Categories", icon: <FaList /> },
    { name: "Credit Cards", icon: <FaCreditCard /> },
    { name: "Stores", icon: <FaStore /> },
    { name: "Products", icon: <FaBoxOpen /> },
    { name: "Deals", icon: <FaTags /> },
    { name: "Marketing", icon: <FaBullhorn /> },
    { name: "Settings", icon: <FaCog /> },
  ];

  return (
    <div className="h-screen flex flex-col">
      {/* Header */}
      <header className="w-full flex justify-between items-center px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200 bg-white shadow-sm">
        <div className="flex items-center gap-3">
          {/* Hamburger for mobile */}
          <button
            className="lg:hidden text-gray-700"
            onClick={() => setIsSidebarOpen(true)}
            aria-label="Toggle Menu"
          >
            <FaBars size={22} />
          </button>

          {/* --- Official Branding --- */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/logo1.png"
              alt="BillionDeals"
              className="h-10 md:h-12 w-auto object-contain"
            />
            <span className="text-xl font-bold text-gray-800 hidden md:inline">
              Billion Deals
            </span>
          </Link>
        </div>

        {/* Header Buttons / Profile */}
        <div className="flex items-center gap-2 sm:gap-4 ml-auto flex-wrap justify-end">
          <button className="px-3 sm:px-4 py-1 rounded-full flex items-center gap-1.5 sm:gap-2 bg-gray-100 hover:bg-gray-200 transition text-xs sm:text-sm">
            <FaHistory size={14} className="sm:size-4" /> History
          </button>
          <button className="px-3 sm:px-4 py-1 rounded-full flex items-center gap-1.5 sm:gap-2 bg-gray-100 hover:bg-gray-200 transition text-xs sm:text-sm">
            <FaUsers size={14} className="sm:size-4" /> Admin Users
          </button>
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full overflow-hidden border cursor-pointer">
            <img
              src="https://i.pravatar.cc/100"
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </header>

      {/* Layout */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <aside
          className={`fixed lg:static top-[64px] lg:top-0 left-0 z-20 w-64 bg-white 
            border-r border-gray-200 flex flex-col transform transition-transform duration-300 
            ${
              isSidebarOpen
                ? "translate-x-0"
                : "-translate-x-full lg:translate-x-0"
            }`}
        >
          <div className="lg:hidden flex justify-end p-3">
            <button
              className="text-gray-600"
              onClick={() => setIsSidebarOpen(false)}
            >
              <FaTimes size={20} />
            </button>
          </div>

          <nav className="flex-1 overflow-y-auto px-3 pb-3 space-y-1.5">
            {menuItems.map((item) => (
              <button
                key={item.name}
                onClick={() => {
                  setActiveMenu(item.name);
                  setIsSidebarOpen(false);
                }}
                className={`w-full text-left flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all duration-200 ${
                  activeMenu === item.name
                    ? "bg-gray-200 font-semibold border-l-4 border-black shadow-sm"
                    : "hover:bg-gray-100"
                }`}
              >
                {item.icon} {item.name}
              </button>
            ))}
          </nav>

          <div className="border-t p-3">
            <button
              onClick={logout}
              className="w-full flex items-center gap-2 px-4 py-2 rounded-lg text-red-600 hover:bg-red-50 transition"
            >
              <FaSignOutAlt /> Logout
            </button>
          </div>
        </aside>

        {/* Main content */}
        <div className="flex-1 flex flex-col">
          <main className="flex-1 overflow-y-auto p-4 sm:p-6 bg-gray-50">
            {activeMenu === "Credit Cards" ? (
              <CreditCardPanel />
            ) : activeMenu === "Stores" ? (
              <StoresPanel />
            ) : activeMenu === "Products" ? (
              <ProductPanel />
            ) : activeMenu === "Users" ? (
              <UsersPanel />
            ) : activeMenu === "Deals" ? (
              <DealsPanel />
            ) : activeMenu === "Marketing" ? ( 
              <MarketingPanel />
            ) : activeMenu === "Settings" ? (
              <SettingsPanel />
            ) : activeMenu === "Product Categories" ? (
              <ProductCategoryPanel />
            ) : (
              <DashboardPanel />
            )}
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AdminPage;
